import React from "react"
import styles from "./page-frame.module.scss"

export default ({ children, mode = 0 }) =>
<div className={[
	styles.ctr,
	mode===1?styles.ctr1:mode===2?styles.ctr2:null
].filter(item => item !== null)
.join(" ")}>{children}</div>